import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

const CharacterCountGroup = styled(Group)`
  margin-top: ${rem(4)};
`

const CharacterCountText = styled(Caption)`
  color: ${props => props.theme.palette.messaging.critical.normalForeground};
`

interface Props {
  characterCount: number
  maxLength: number
}

export default function CharacterLimitWarning({ characterCount, maxLength }: Props) {
  return (
    <CharacterCountGroup direction="horizontal" gap={8} verticalAlign="center" horizontalAlign="space-between">
      <CharacterCountText variant="small">
        Character limit reached
      </CharacterCountText>
      <CharacterCountText variant="small">
        {characterCount} / {maxLength}
      </CharacterCountText>
    </CharacterCountGroup>
  )
}
